var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.986,
    height: 14,
    viewBox: "0 0 13.986 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1382",
    "data-name": "Path 1382",
    d: "M6.716-12.136a.659.659,0,0,0-.7-.029L-6.669-4.946a.66.66,0,0,0-.33.61.656.656,0,0,0,.4.566l4.192,1.76v3.1a.657.657,0,0,0,.342.576.632.632,0,0,0,.29.081.659.659,0,0,0,.355-.1L1.621-.308,4.316.824A.657.657,0,0,0,4.57.875.653.653,0,0,0,4.893.79.655.655,0,0,0,5.219.315L6.969-11.5A.6.6,0,0,0,6.716-12.136ZM3.1-8.991-2.018-3.279-4.861-4.465ZM-1.118-.109v-1.35l1.27.533Zm5.187-.6L-.76-2.742,5.381-9.565Z",
    transform: "translate(7 12.25)",
    fill: "#fefeff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.7507d9049342bbf70323714b372b6577.svg";
export { ForwardRef as ReactComponent };